import { cn } from '@eliadmin/core/src/utils/style-utils';
import { ReferenceSkeletonItem } from './reference-skeleton-item';

export const ReferencesSkeleton = () => {
  return (
    <div
      className={cn(
        'animate-pulse',
        'col-span-1 grid w-full grid-cols-1 gap-8 sm:col-span-2 sm:grid-cols-2 lg:col-span-3 lg:grid-cols-3 lg:gap-10',
      )}
    >
      <ReferenceSkeletonItem />
      <ReferenceSkeletonItem />
      <ReferenceSkeletonItem />
      <ReferenceSkeletonItem />
      <ReferenceSkeletonItem />
    </div>
  );
};
